module.exports = __webpack_public_path__ + "img/photolight_thumbnail-400x300.09f2ae36.jpg";